import React from "react";

interface IParams {
  direction: "left" | "right";
  onClick: () => void;
  disabled: boolean;
}

const CustomSlideArrowButton: React.FC<IParams> = ({ direction, onClick, disabled }) => {
  return (
    <>
    {!disabled && (<>
      <button 
      disabled={disabled} // Disabilita il pulsante se 'disabled' è true
      className={`specificCss image-gallery-custom-${direction}`} onClick={onClick}>
        <i
          className={`fas fa-6x fa-chevron-${direction} custom-gallery-icon-${direction}`}
        ></i>
      </button>
    </>)}
     
    </>
  );
};

export default CustomSlideArrowButton;
